import { FailureKind } from '@/hooks/api/assets/useGetRecentFailures';

const FAILURE_LINKS: Record<FailureKind, (id: string) => string> = {
  asset: id => `asset/${id}`,
  report: id => `report/${id}`,
  'part-finder-report': id => `part-finder-reports/${id}`,
};

export const failureLink = (kind: FailureKind, id: string) => FAILURE_LINKS[kind](id);
